import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";

import { getAllOnGoingProjectAction } from "../../Redux/Actions/ProjectActions";

import ProjectCard from "../ProjectCard/ProjectCard";
import './HProjectSection.css'

const HProjectSection = () => {

  const dispatch = useDispatch()
  const isLoading = useSelector((e) => e?.LoadingReducer?.isLoading)
  const ongoingProjectList = useSelector((e) => e?.ProjectReducer?.ongoingProjectList)

  useEffect(() => {
    getDetails()
  }, [])

  const getDetails = () => {
    dispatch(getAllOnGoingProjectAction())
  }

  const visibleProject = ongoingProjectList?.slice(0, 4);

  return (
    <section className="hproject-section">

      <div className="container pb-5 pt-5" >
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className="mb-4 text-primary fw-bold border-start border-4 ps-2">Projects</h5>
          <Link to="/projects" className="text-primary fw-medium">View More →</Link>
        </div>

        {
          isLoading ?
            <div className='text-center'>
              <Spinner animation="border" />
            </div>
            :
            <div className="row g-4">
              {
                visibleProject.map((item, index) => (
                  <div className="col-12 col-sm-6 col-md-3" key={index}>
                    <div className="card research-card h-100">
                      <ProjectCard
                        src={`https://api.coeupdspadelhi.in/uploads/${item?.image}`}
                        params={item}
                        path={`project/${item?.name}`}
                        title={item.name}
                      />
                    </div>
                  </div>
                ))
              }
            </div>
        }

      </div>

    </section>
  );
};

export default HProjectSection;